/**
 * Converts points to dollars using the conversion rate of 100 points = $1
 * @param points - The number of points to convert
 * @returns The formatted dollar amount string (e.g., "5.00")
 */
export function pointsToDollars(points: number): string {
  const dollars = points / 100
  return dollars.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
